<template>
    <div>
        <h1>Contact Journey North</h1>
        <ul v-if="errors.length" class="error">
            <li v-for="error in errors" v-bind:key="error">
                {{ error }}
            </li>
        </ul>
        <form
            v-if="isInitial || isSaving"
            @submit.prevent="contact"
            novalidate="true"
        >
            <div>
                <label for="name">
                    Name*
                </label>
                <input v-model="name" type="text" id="name" name="name" value />
            </div>

            <div>
                <label for="email">
                    Email*
                </label>
                <input v-model="email" type="email" name="email" value />
            </div>

            <div>
                <label for="subject">
                    Subject*
                </label>
                <input
                    v-model="subject"
                    type="text"
                    id="subject"
                    name="subject"
                    value
                />
            </div>

            <div>
                <label for="message">Message*</label>
                <textarea v-model="message" name="message" id="message">
                </textarea>
            </div>

            <div>
                <button type="submit" name="button">Submit Message</button>
            </div>
        </form>
        <div v-if="isSuccess">
            <h2>Message Sent</h2>
            <p>
                We&rsquo;ll be in touch.
            </p>
        </div>
        <div v-if="isFailed">
            <h2>Message Failed</h2>
            <p>
                <a href="javascript:void(0)" @click="reset()">Try again</a>
            </p>
            <p>{{ messageError }}</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3
// let fd = new FormData()

export default {
    data() {
        return {
            name: '',
            email: '',
            subject: '',
            message: '',
            currentStatus: null,
            messageError: '',
            errors: []
        }
    },
    created() {
        this.reset()
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL
        },
        contact() {
            this.errors = []
            if (this.name.length < 2) {
                this.errors.push('Name is a required field.')
            }
            if (this.subject.length < 2) {
                this.errors.push('Subject is a required field.')
            }
            if (this.message.length < 2) {
                this.errors.push('Message is a required field.')
            }
            if (this.email.length < 7) {
                this.errors.push('Email is a required field.')
            }
            if (!this.validEmail(this.email)) {
                this.errors.push('Please enter a valid email address.')
            }
            if (this.errors.length > 0) {
                return false
            }

            this.currentStatus = STATUS_SAVING

            return axios
                .post(
                    process.env.VUE_APP_API_DOMAIN + '/contact',
                    {
                        email: this.email,
                        name: this.name,
                        subject: this.subject,
                        message: this.message
                    },
                    {
                        headers: {
                            Accept: 'application/json'
                        }
                    }
                )
                .then(response => {
                    console.log(response)
                    this.currentStatus = STATUS_SUCCESS
                })
                .catch(err => {
                    this.messageError = err.response.data.message
                    this.currentStatus = STATUS_FAILED
                })
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(email)
        }
    }
}
</script>
